import type { ReactNode } from 'react';

export const symbol_work_history: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-180v-480 480-21.75V-180Zm0 60q-24 0-42-18t-18-42v-480q0-24 18-42t42-18h180v-100q0-23 18-41.5t42-18.5h200q24 0 42 18.5t18 41.5v100h180q24 0 42 18t18 42v177q0 12.64-8.68 20.82-8.67 8.18-21.5 8.18-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-176H140v480h328q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H140Zm240-600h200v-100H380v100Zm204 616q-57-57-57-136t57-136q57-57 136-57t136 57q57 57 57 136t-57 136q-57 57-136 57t-136-57Zm153-138v-103.04q0-8.96-6-14.96t-15-6q-9 0-15 6t-6 14.97V-243q0 6.07 2.5 11.76 2.5 5.69 7.5 10.24l76 70q5 5 13 4.5t13-5.5q6-6 5.5-14t-6.5-13l-69-63Z"
		/>
	</svg>
);
